import React from 'react'
import './api-keys.scss'

// A segmented control (the API key form's permission levels and its expiry;
// owner 2026-10-29, "API key form" in CLAUDE.md): one real radio per option,
// inside its own label, so the group is a radio group to every reader and the
// keyboard (Tab to it, arrows between options). The radio itself is invisible
// over its segment; the chosen segment is raised. An option marked `grant`
// (a level above No access) takes the primary tone when chosen, so a granted
// row reads at a glance.
//
// An option marked `unavailable` (a level a resource group doesn't have, in
// the permission rows' fixed columns) is drawn as a muted, disabled segment:
// its radio is disabled (never focused, skipped by the arrow keys, never
// chosen) and aria-disabled, and `title` says why.
//
// options: [{ value, label, grant, unavailable, title }]; labelledBy names the
// group; name groups the radios (unique on the page). disabled locks every
// option.
export const SegmentedChoice = ({ name, labelledBy, describedBy, options, value, onChange, disabled = false, className }) =>
  <div className={`ak-seg${className ? ` ${className}` : ''}`} role="radiogroup" aria-labelledby={labelledBy} aria-describedby={describedBy}>
    {options.map(option => {
      const checked = value === option.value
      const off = Boolean(option.unavailable)
      const classes = ['ak-seg-option', checked && 'is-checked', option.grant && 'is-grant', (disabled || off) && 'is-disabled', off && 'is-unavailable'].filter(Boolean).join(' ')
      return (
        <label key={option.value} className={classes} title={option.title}>
          <input type="radio" className="ak-seg-input" name={name} value={option.value} checked={checked} disabled={disabled || off}
            aria-disabled={off ? 'true' : undefined} onChange={() => onChange(option.value)} />
          <span>{option.label}</span>
        </label>
      )
    })}
  </div>
